import React, { useEffect, useState } from "react";
import { Box, Card, CardContent } from "@mui/material";
import { Button, DateField, EmailField, FunctionField, Labeled, SimpleShowLayout, TextField, TopToolbar, useGetOne, useRedirect } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import { useParams } from "react-router-dom";
import { formatPhoneNumberStrict, formatPostalCode } from "../common";

const RequesterShow = () => {
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams(); 

  const redirect = useRedirect();

  const { data, isLoading } = useGetOne("requesters", { id });
  useEffect(() => {
    if(!isLoading && data){
      setRecord(data);
    }
  },[data,isLoading]);

  const CustomTopToolbar = () => (
    <Box sx={{ padding: 0, margin: 0 }}>
        <TopToolbar>
            <Button
                label="管理業者編集"
                onClick={() => redirect(`/requesters/${id}`)}
                startIcon={<EditIcon />}
            />
        </TopToolbar>
    </Box>
  );

  const labelStyle = (text) => (
    <div style={{ backgroundColor: "#eee", color: "#666", paddingLeft: "5px" }}>
      {text}
    </div>
  );

  return (
    <>
      <CustomTopToolbar/>
      <Card>
        <CardContent>
            <SimpleShowLayout record={record}>
              {/* <FunctionField label={labelStyle("名前")} style={{ paddingLeft: "5px" }} 
                render={(record) =>{
                  return `${record.surname ?? ""} ${record.name ?? ""}`
                }}
              /> */}
              <TextField source="companyName" label={labelStyle("会社名")} style={{ paddingLeft: "5px" }} />
              <FunctionField
                label={labelStyle("住所")} style={{ paddingLeft: "5px" }} 
                render={record => {
                  return `${record.postCode ? record.postCode : ""} ${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}`;
                }}
              />
                  <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                    <Labeled label={labelStyle("電話番号１")} style={{ flex: 1, marginRight: "10px" }}>
                      <FunctionField
                        render={(record) => record.phone ?? ""}
                        style={{ paddingLeft: "5px", width: "100%" }}
                      />
                    </Labeled>
                    <Labeled label={labelStyle("電話番号２")} style={{ flex: 1, marginRight: "10px" }}>
                      <FunctionField
                        render={(record) => record.telephone ?? ""}
                        style={{ paddingLeft: "5px", width: "100%" }}
                      />
                    </Labeled>
                  
                    <Labeled label={labelStyle("FAX")} style={{ flex: 1}}>
                      <FunctionField
                        render={(record) => record.fax ?? ""}
                        style={{ paddingLeft: "5px", width: "100%" }}
                      />
                    </Labeled>                                       
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                    <Labeled label={labelStyle("備考")} style={{ flex: 1}}>
                      <FunctionField
                        render={(record) => record.remarks ?? ""}
                        style={{ paddingLeft: "5px", width: "100%" }}
                      />
                    </Labeled>
                  </div>
              <DateField source="createDate" label={labelStyle("登録日")} style={{ paddingLeft: "5px" }} />
              <DateField source="updateDate" label={labelStyle("更新日")} style={{ paddingLeft: "5px" }} />
            </SimpleShowLayout>
        </CardContent>
      </Card>
    </>

  );
};

export default RequesterShow;

